import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetRestVial(id: string | undefined) {
  return useQuery(queries.stocks.getRestVialById(id || ''))
}
